<template>
  <v-container v-if="access.includes(roles.schedules)">
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="64">
          <v-toolbar
            flat
          >
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              Today
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="prev"
            >
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="next"
            >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
          </v-toolbar>
        </v-sheet>
        <v-sheet>
          <v-progress-linear
            v-if="loading_shiftcalendar"
            indeterminate
            rounded
            height="6"
          />
          <v-calendar
            ref="calendar"
            v-model="calendar"
            color="primary"
            :type="type"
            @change="updateRange"
          >
            <template v-slot:day="{ date, outside, future }">
              <v-col
                v-if="(!shiftcalendar[date] && !outside) || shiftcalendar[date] && Number(shiftcalendar[date][0]) < 1 && !outside && future"
                style="height: 65px !important;"
              ></v-col>
              <v-col v-if="(shiftcalendar[date] && !outside && !future) || ((shiftcalendar[date] && shiftcalendar[date][0]) > 0 && future)">
                <div>
                  <v-btn
                    text
                    rounded
                    style="padding: 20px !important;"
                  >
                    <v-icon
                      :class="{
                        'info--text': Number(shiftcalendar[date][0]) > 0,
                        'error--text': Number(shiftcalendar[date][0]) < 1,
                      }"
                    >
                      mdi-account-multiple-check
                    </v-icon>{{ shiftcalendar[date][0] }}
                    <v-icon
                      :class="{
                        'warning--text': Number(shiftcalendar[date][0]) > 0,
                        'error--text': Number(shiftcalendar[date][0]) < 1,
                      }"
                    >
                      mdi-fingerprint
                    </v-icon>{{ shiftcalendar[date][1] }}
                  </v-btn>
                </div>
              </v-col>
            </template>
          </v-calendar>
        </v-sheet>
      </v-col>
    </v-row>
    <v-card
      class="mx-auto set-height"
    >
      <v-card-title>
        <v-btn
          text
          :class="{ selected: (select_view == 1) }"
          @click="select_view = 1"
        >
          Shift Data
        </v-btn>
        <v-spacer />
        <v-col
          v-if="(select_view == 1)"
          md="4"
        >
          <v-text-field
            v-model="search_input"
            append-icon="mdi-magnify"
            label="Search"
            class="menu-items"
            @keydown.enter="OnSearchInput"
          />
        </v-col>
        <v-col
          v-if="(select_view == 1)"
          md="2"
        >
          <v-btn
            color="grey darken-2"
            outlined
            @click="ShowExport()"
          >
            Export to Excel
          </v-btn>
        </v-col>
      </v-card-title>
      <div>
        <v-data-table
          v-if="(select_view == 1)"
          :headers="headers_shift_data"
          :items="shift_data"
          :options.sync="options"
          :server-items-length="total"
          :loading="loading_shift_data"
          :disable-sort="true"
          :loading-text="loading_text"
          class="elevation-1 text-no-wrap"
        >
          <template v-slot:[`item.created_at`]="{ item }">
            {{ GetDateFormat(item.created_at) }}
          </template>
        </v-data-table>
      </div>
      <v-card-title>
        <div class="primary--text">
          Schedules Summary
        </div>
        <v-spacer />
        <v-col
          v-if="access.includes(roles.stores_switch)"
          cols="12"
          sm="6"
          md="4"
        >
        <v-select
          ref="role"
          v-model="select_pc"
          label="PROFIT CENTER"
          :items="profit_centers"
          item-text="description"
          item-value="uid"
          :loading="loading_pc"
        />
        </v-col>
      </v-card-title>
      <div>
        <v-data-table
          :headers="headers_summary"
          :items="summary"
          :loading="loading_summary"
          :options.sync="options_summary"
          :server-items-length="total_summary"
          :disable-sort="true"
          :loading-text="loading_text"
          hide-default-header
          class="elevation-1 text-no-wrap sticky"
        >
          <template v-slot:progress>
            <v-progress-linear
              v-if="loading_summary"
              indeterminate
            />
          </template>
          <template v-slot:header="{ props }">
            <thead
              :class="{ hidden: loading_summary}"
              class="v-data-table-header"
            >
              <tr>
                <th
                  :class="{ 'text-center': true, title: true }"
                  rowspan="2"
                  style="border: thin solid rgba(0, 0, 0, 0.12);"
                >
                  <span>Store</span>
                </th>
                <th
                  v-for="(header, index) in headers_summary2"
                  :key="header.value + index"
                  :class="{ 'text-center': true, title: true }"
                  colspan="2"
                  style="border-top: solid thin rgba(0, 0, 0, 0.12);
                    border-right: solid thin rgba(0, 0, 0, 0.12);
                    border-bottom: solid thin rgba(0, 0, 0, 0.12);
                  "
                >
                  <span>{{ header.text }}</span>
                </th>
              </tr>
              <tr>
                <th
                  v-for="(header, index) in props.headers"
                  :key="header.text + index"
                  :class="{ 'text-start': true, title: true, hidden: (header.text === 'Store') }"
                  style="border-right: solid thin rgba(0, 0, 0, 0.12);
                    border-bottom: solid thin rgba(0, 0, 0, 0.12);
                  "
                >
                  <span>{{ header.text }}</span>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:body="{ items, headers }">
            <tr
              v-for="(item, idx) in items"
              :key="idx"
              style="line-height: 12px !important;font-size: 12px !important;"
            >
              <td
                v-for="(header,key) in headers"
                :key="key"
                style="border-right: solid thin rgba(0, 0, 0, 0.12);
                  border-bottom: solid thin rgba(0, 0, 0, 0.12);
                "
                :class="{ customgrid: header.value !=='Store' }"
              >
                <strong
                  v-if="header.value ==='Store'"
                >
                  {{ item[header.value] }}
                </strong>
                <strong
                  v-if="header.value !=='Store' && Number(item[header.value]) === 0"
                  class="red--text"
                >
                  {{ item[header.value] }}
                </strong>
                <v-chip
                  v-if="header.value !=='Store' && Number(item[header.value]) !== 0 && header.text === 'Crew'"
                  class="ma-2 text-center"
                  color="info"
                  style="margin:0px !important; padding:0 6px!important;"
                >
                  {{ item[header.value] }}
                </v-chip>
                <v-chip
                  v-if="header.value !=='Store' && Number(item[header.value]) !== 0 && header.text === 'Hours'"
                  class="ma-2"
                  color="warning"
                  style="margin:0px !important; padding:0 6px!important;"
                >
                  {{ item[header.value] }}
                </v-chip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <!-- File content dialog -->
    <v-dialog
      v-model="show_file_content"
      max-width="30%"
    >
      <v-card :loading="loading_file_content">
        <v-card-title class="text-left">
          <h2 class="primary--text">
            {{ file_name }}
          </h2>
        </v-card-title>
        <v-card-text>
          {{ file_content }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="show_file_content = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End file content dialog -->

    <!-- Export to Excel dialog -->
    <v-dialog
      v-model="show_export"
      width="40%"
      max-width="40%"
    >
      <v-card>
        <v-card-title class="text-left">
          <h2 class="primary--text">
            Export To Excel
          </h2>
        </v-card-title>
        <v-card-text>
          <v-col
            v-if="access.includes(roles.stores_switch)"
            cols="12"
            sm="10"
          >
          <v-select
            ref="role"
            v-model="select_pc2"
            :items="profit_centers"
            item-text="description"
            item-value="uid"
            :loading="loading_pc"
            clearable
          >
            <template v-slot:label>
              <div>
                PROFIT CENTER <small>(optional)</small>
              </div>
            </template>
          </v-select>
          </v-col>
          <v-col
            cols="12"
            sm="10"
          >
            <v-text-field
              v-model="personnelidno"
              clearable
              :counter="10"
              :rules="[
                v => v.length ==0 || (v.length == 10 && /^\d*$/.test(v)) || 'Must be 10 characters long, all numeric.'
              ]"
            >
              <template v-slot:label>
                <div>
                  PERSONNELIDNO <small>(optional)</small>
                </div>
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="10"
          >
            <v-menu
              v-model="date_menu_from"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date_from"
                  label="Date From"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date_from"
                @input="OnDateInput"
              />
            </v-menu>
            <v-menu
              v-model="date_menu_to"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date_to"
                  label="Date To"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date_to"
                @input="OnDateInput"
              />
            </v-menu>
          </v-col>
          <v-btn
            color="green darken-1"
            text
            plain
            style="text-decoration: underline;opacity:1;"
            :class="{ hidden: filename == ''}"
            :disabled="in_process"
            :href="filename"
            target="_blank"
            download
          >
            Download File
          </v-btn>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="generating"
            color="green darken-1"
            text
            loading
          />
          <v-btn
            color="green darken-1"
            text
            :disabled="generating"
            @click="ExportToExcel()"
          >
            Generate
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="generating"
            @click="show_export = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Export to Excel dialog -->
    <confirm ref="confirm" />
  </v-container>
</template>
<script>
  import moment from 'moment'
  import {
    mapState,
  } from 'vuex'
  import {
    ShiftData,
    GetShiftsSummary,
    GetShiftCalendar,
  } from '@/graphql/Shift.gql'
  import {
    ExportToExcel,
  } from '@/graphql/File.gql'
  export default {
    components: {
      Confirm: () => import('@/views/dashboard/component/Confirm'),
    },
    data () {
      return {
        summary_load: false,
        select_pc: '',
        select_pc2: '',
        calendar: '',
        shiftcalendar: [],
        type: 'month',
        loading_shiftcalendar: false,
        skip_shiftcalendar: true,
        start: '',
        end: '',
        select_view: 1,
        shift_data: [],
        summary: [],
        loading_text: 'Please wait while loading data...',
        headers_shift_data: [
          { text: 'PERSONNELIDNO', value: 'personnelidno', class: 'title' },
          { text: 'Crew Name', value: 'name', class: 'title' },
          { text: 'Reference Date', value: 'date', class: 'title' },
          { text: 'Shift', value: 'shift', class: 'title' },
          { text: 'Hours', value: 'hours', class: 'title', align: 'right' },
          { text: 'Date Created', value: 'created_at', class: 'title' },
        ],
        headers_summary: [],
        headers_summary2: [],
        loading_summary: true,
        skip_summary: true,
        loading_shift_data: true,
        skip_shift_data: true,
        search: '',
        search_input: '',
        total: 0,
        options: {
          page: 1,
          itemsPerPage: 10,
        },
        total_summary: 0,
        options_summary: {
          page: 1,
          itemsPerPage: 10,
        },
        uid: '',
        show_export: false,
        personnelidno: '',
        generating: false,
        date_menu_from: false,
        date_menu_to: false,
        date_from: moment().format('YYYY-MM-DD'),
        date_to: moment().format('YYYY-MM-DD'),
      }
    },
    computed: {
      ...mapState(['in_process', 'default_error', 'access', 'roles', 'profit_centers', 'profit_centers_hash', 'profit_center_default']),
    },
    watch: {
      options: {
        handler () {
          this.GetShiftData()
        },
        deep: true,
      },
      options_summary: {
        handler () {
          if (this.summary_load) { this.GetShiftsSummary() }
        },
        deep: true,
      },
      select_pc: {
        handler () {
          if (this.summary_load) { this.GetShiftsSummary() }
        },
        deep: true,
      },
    },
    mounted () {
      window.scrollTo(0, 0)
      if (this.$refs.calendar) this.$refs.calendar.checkChange()
    },
    methods: {
      setToday () {
        this.calendar = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      updateRange ({ start, end }) {
        this.start = start.date
        this.end = end.date
        this.GetShiftCalendar()
        this.GetShiftData()
        // preload summary
        this.summary = []
        this.headers_summary = []
        this.headers_summary2 = []
        this.loading_summary = true
      },
      GetShiftCalendar () {
        this.shiftcalendar = []
        this.loading_shiftcalendar = true
        this.skip_shiftcalendar = false
        this.$apollo.queries.GetShiftCalendar.refetch()
      },
      GetHoursSpan (datein, dateout, timein, timeout) {
        const s = this.GetDateTimeSpan(
          datein + ' ' + this.FormatTime('0000'.substring(0, 4 - timein.length) + timein),
          dateout + ' ' + this.FormatTime('0000'.substring(0, 4 - timeout.length) + timeout),
        )
        return Math.round(s * 100) / 100
      },
      FormatTime (t) {
        return moment(t, 'HHmm').format('HH:mm')
      },
      GetDateFormat (d) {
        if (!d) { return '' }
        return moment(d).format('YYYY-MM-DD hh:mm A')
      },
      GetStatus (s) {
        if (!s) { return 'Pending' }
        if (s === 3 || s === 5) { return 'Duplicate' }
        if (s === 6 || s === 8) { return 'Pending' }
        if (s === 7) { return 'Out of range' }
        if (s === 9) { return 'Invalid hours' }
        if (s === 10) { return 'No logout' }
      },
      OnSearchInput (e) {
        this.search = this.search_input
        this.options.page = 1
        this.GetShiftData()
      },
      GetShiftData () {
        this.loading_shift_data = true
        this.shift_data = []
        this.skip_shift_data = false
      },
      GetShiftsSummary () {
        if (this.select_pc === '') { this.select_pc = this.profit_center_default }
        this.summary = []
        this.headers_summary = []
        this.headers_summary2 = []
        this.loading_summary = true
        this.skip_summary = false
        this.$apollo.queries.GetShiftsSummary.refetch()
      },
      OnDateInput () {
        this.date_menu_from = false
        this.date_menu_to = false
      },
      ShowExport () {
        if (!this.access.includes(this.roles.schedules_export)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.filename = ''
        this.personnelidno = ''
        this.date_from = moment().format('YYYY-MM-DD')
        this.date_to = moment().format('YYYY-MM-DD')
        this.show_export = true
      },
      ExportToExcel () {
        const shift = 210
        this.generating = true
        this.filename = ''
        this.$apollo.mutate({
          mutation: ExportToExcel,
          variables: {
            uid: this.select_pc2,
            hash: this.profit_centers_hash,
            personnelidno: this.personnelidno,
            date_from: this.date_from,
            date_to: this.date_to,
            type: shift,
          },
        }).then((res) => {
          if (res.data.ExportToExcel.status === 'Ok') {
            this.filename = res.data.ExportToExcel.data[0].filename
          } else if (res.data.ExportToExcel.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.ExportToExcel.status)
          }
          this.generating = false
        }).catch(error => {
          this.CheckError(error)
          error = false
          this.generating = false
        })
      },
      ParseJSON (o) {
        try {
          return JSON.parse(o)
        } catch (e) {
          return ''
        }
      },
    },
    apollo: {
      ShiftData: {
        error (error) {
          this.loading_shift_data = false
          this.CheckError(error)
        },
        query: ShiftData,
        variables () {
          return {
            date: this.start,
            per_page: this.options.itemsPerPage || 10,
            page: this.options.page || 1,
            search: this.search,
          }
        },
        skip () {
          return this.skip_shift_data
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data.ShiftData && data.ShiftData.status === 'Ok') {
              this.shift_data = data.ShiftData.data
              this.total = data.ShiftData.total
              this.loading_shift_data = false
              this.skip_shift_data = true
              this.GetShiftsSummary()
            } else if (data.ShiftData.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            }
          }
        },
      },
      GetShiftCalendar: {
        error (error) {
          this.loading_shiftcalendar = false
          this.CheckError(error)
        },
        query: GetShiftCalendar,
        variables () {
          return {
            date: this.start,
          }
        },
        skip () {
          return this.skip_shiftcalendar
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetShiftCalendar) {
              if (data.GetShiftCalendar.status === 'Ok') {
                var shift = this.ParseJSON(data.GetShiftCalendar.data)
                if (shift.length > 0) {
                  var m = moment(shift[0].year + '-' + shift[0].month.padStart(2, '0') + '-01')
                  for (var key in shift[0]) {
                    if (['id', 'store_number', 'year', 'month'].includes(key)) {
                      // exclude
                    } else {
                      if (Number(key.replace('c', '')) > m.daysInMonth()) { continue }
                      if (key.includes('c')) {
                        this.shiftcalendar[shift[0].year + '-' + shift[0].month.padStart(2, '0') + '-' + key.replace('c', '').padStart(2, '0')] = [shift[0][key], Number(shift[0][key.replace('c', 'h')])]
                      }
                    }
                  }
                }
              } else if (data.GetShiftCalendar.status === '0') {
                this.CheckError({ message: 'Session expired!' })
              } else {
                this.$store.commit('ShowError', data.GetShiftCalendar.status)
              }
              this.loading_shiftcalendar = false
              this.skip_shiftcalendar = true
            }
          }
        },
      },
      GetShiftsSummary: {
        error (error) {
          this.loading_summary = false
          this.CheckError(error)
        },
        query: GetShiftsSummary,
        variables () {
          return {
            uid: this.select_pc,
            hash: this.profit_centers_hash,
            date: this.start,
            per_page: this.options_summary.itemsPerPage || 10,
            page: this.options_summary.page || 1,
          }
        },
        skip () {
          return this.skip_summary
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetShiftsSummary) {
              this.loading_summary = false
              this.skip_summary = true
              var shift = this.ParseJSON(data.GetShiftsSummary.data)
              var m = shift.length > 0 ? moment(shift[0].year + '-' + shift[0].month.padStart(2, '0') + '-01') : ''
              for (var key in shift[0]) {
                if (key.toLowerCase() === 'store') {
                  this.headers_summary.push({
                    text: key, value: key, class: 'title',
                  })
                } else if (['id', 'store_number', 'year', 'month'].includes(key)) {
                  // exclude
                } else {
                  this.headers_summary.push({
                    text: key.substring(0, 1) === 'c' ? 'Crew' : 'Hours', value: key, class: 'title',
                  })
                  if (key.substring(0, 1) === 'c') {
                    if (Number(key.replace('c', '')) > m.daysInMonth()) { continue }
                    this.headers_summary2.push({
                      text: key.replace('c', m.format('MMM') + ' '), value: key, class: 'title',
                    })
                  }
                }
              }
              this.summary = shift
              this.total_summary = data.GetShiftsSummary.total
              this.summary_load = true
            }
          }
        },
      },
    },
  }
</script>
